import { useState } from "react"

export const VariablePolitics = () => {
    const [state, setState] = useState({
        editorValuePrivacy: "",
        editorValueAbout: "",
        LoadPrivacy: false,
        LoadAbout: false
    })
    const setLoadPrivacy = (value) => {
        setState((prevState) => ({
            ...prevState,
            LoadPrivacy: value,
        }));
    };
    const setLoadAbout = (value) => {
        setState((prevState) => ({
            ...prevState,
            LoadAbout: value,
        }));
    };
    const handleChangePolitics = (value, variableName) => {
        setState((prevState) => ({
            ...prevState,
            [variableName]: value,
        }));
    };
    return {
        ...state,
        state,
        setState,
        handleChangePolitics,
        setLoadPrivacy,
        setLoadAbout
    }
}